import SwitchToggle from "../Utilities/SwitchToggle";
import {useEffect, useState} from "react";
import CategorySelect2 from "../Product/Category/CategorySelect2";
import BrandSelect from "../Product/Category/BrandSelect";
import {useLocation, useNavigate} from "react-router-dom";
import BrandSelect2 from "../Product/Category/BrandSelect2";
import ShopSelect from "../Shop/ShopSelect";
import ProductSelect2 from "../Product/ProductSelect2";

export default function FilterInventory({SetFilterQuery, filterQuery}){
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);

    // بازیابی فیلترها از URL اگر وجود داشته باشند
    const initialFilter = (() => {
        try {
            return params.get('filters') ? JSON.parse(decodeURIComponent(params.get('filters'))) : {};
        } catch (e) {
            return {};
        }
    })();

    const [query,setQuery] = useState(initialFilter);
    const [filter,setFilter] = useState(initialFilter);
    const [updateData, setUpdateData] = useState('0')
    const [applyFilter, setApplyFilter] = useState(Object.keys(initialFilter).length > 0)

    const [selectedCategory, setSelectedCategory] = useState(initialFilter.category || []);
    const [selectedBrand, setSelectedBrand] = useState(initialFilter.brand || []);
    const [selectedShop, setSelectedShop] = useState(initialFilter.shop_id || '');

    // اعمال فیلترها هنگام بارگذاری اولیه صفحه
    useEffect(() => {
        if (Object.keys(initialFilter).length > 0) {
            SetFilterQuery(initialFilter);
            if (initialFilter.category) {
                setSelectedCategory(initialFilter.category);
            }
            if (initialFilter.brand) {
                setSelectedBrand(initialFilter.brand);
            }
            if (initialFilter.shop_id) {
                setSelectedShop(initialFilter.shop_id);
            }   
        }
    }, []);
    
    // تابع برای ریست کردن فیلترها
    const resetFilters = () => {
        // حذف پارامترهای فیلتر از URL
        const currentParams = new URLSearchParams(location.search);
        currentParams.delete('filters');
        currentParams.delete('term');
        currentParams.delete('by');
        currentParams.delete('status');
        // حفظ پارامتر id اگر وجود داشته باشد
        navigate('?' + currentParams.toString(), { replace: true });
        
        // پاک کردن مقادیر فیلترها
        setQuery({});
        setFilter({});
        SetFilterQuery({});
        setApplyFilter(false);
        setSelectedCategory([]);
        setSelectedBrand([]);
        window.location.replace(window.location.pathname)
    };

    useEffect(() => {
        let arr = []
        if (Array.isArray(selectedCategory)) {
            selectedCategory.forEach(category => {
                if (category && (category.slug || category._id)) {
                    arr.push(category.slug || category._id)
                }
            })
        }
        changeQuery(arr,"category")
    }, [selectedCategory]);

    useEffect(() => {
        let arr = []
        if (Array.isArray(selectedBrand)) {
            selectedBrand.forEach(brand => {
                if (brand && brand.value) {
                    arr.push(brand.value)
                }
            })
        }
        changeQuery(arr,"brand")
    }, [selectedBrand]);

    useEffect(() => {
        changeQuery(selectedShop,"shop_id")
    }, [selectedShop]);

    useEffect(() => {
        setFilter(query)
    }, [query]);

    useEffect(() => {
        SetFilterQuery(filter)
    }, [updateData]);

    const handleMultiSelectCategory = (_selectedCategory) => {
        if (Array.isArray(_selectedCategory)) {
            setSelectedCategory(_selectedCategory);
        }
    }

    const handleMultiSelectBrand = (selectedBrand) => {
        if (Array.isArray(selectedBrand)) {
            setSelectedBrand(selectedBrand);
        }
    }

    const handleMultiSelectShop = (selectedShop) => {
        setSelectedShop(selectedShop?._id ?? '')
    }

    function changeQuery(value , name){
        query[name] = value;
        setQuery({...query})
    }

    return (
        <div className={`show`}>
            <div className="pt-3 pb-4">
                <div className="main-content p-3">
                    <div className="grid-form text-xs grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 2xl:grid-cols-9 gap-3 2xl:gap-4 2xl:gap-y-5">

                        <div>
                            <label>
                                <span className="block">ویژه ها</span>
                                <select
                                    value={query.price_sale || ""}
                                    onChange={ (e) => {
                                        changeQuery(e.target.value,"price_sale")
                                    } }
                                    className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="y">ویژه ها</option>
                                    <option value="n">غیر ویژه ها</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">تاریخ / غیر تاریخ</span>
                                <select
                                    value={query.start_and_end_date || ""}
                                    onChange={ (e) => {
                                        changeQuery(e.target.value,"start_and_end_date")
                                    } }
                                    className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">تاریخ / غیر تاریخ</option>
                                    <option value="none">تاریخ ندارند</option>
                                    <option value="end">شروع دارند</option>
                                    <option value="start">پایان دارند</option>
                                    <option value="both">پایان و شروع دارد</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">شناسه محصول</span>
                                <select
                                    value={query.product_id || ""}
                                    onChange={ (e) => {
                                        changeQuery(e.target.value,"product_id")
                                    } }
                                    className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">دارد ندارد</option>
                                    <option value="y">دارد</option>
                                    <option value="n">ندارد</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">وضعیت قیمت گذاری</span>
                                <select
                                    value={query.price_min_max_status || ""}
                                    onChange={ (e) => {
                                        changeQuery(e.target.value,"price_min_max_status")
                                    } }
                                    className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="min">رد شدن از مرز حداقل</option>
                                    <option value="max">رد شدن از مرز حداکثر</option>
                                    <option value="floor">رد شدن از کف قیمت</option>
                                    <option value="ceil">رد شدن از سقف قیمت</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">وضعیت قیمت گذاری فوری</span>
                                <select
                                    value={query.price_sale_min_max_status || ""}
                                    onChange={ (e) => {
                                        changeQuery(e.target.value,"price_sale_min_max_status")
                                    } }
                                    className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="min">رد شدن از مرز حداقل</option>
                                    <option value="max">رد شدن از مرز حداکثر</option>
                                    <option value="floor">رد شدن از کف قیمت</option>
                                    <option value="ceil">رد شدن از سقف قیمت</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">وضعیت قیمت گذاری ویژه عادی</span>
                                <select
                                    value={query.price_regular_min_max_status || ""}
                                    onChange={ (e) => {
                                        changeQuery(e.target.value,"price_regular_min_max_status")
                                    } }
                                    className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="min">رد شدن از مرز حداقل</option>
                                    <option value="max">رد شدن از مرز حداکثر</option>
                                    <option value="floor">رد شدن از کف قیمت</option>
                                    <option value="ceil">رد شدن از سقف قیمت</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">وضعیت</span>
                                <select
                                    value={query.status || ""}
                                    onChange={ (e) => {
                                        changeQuery(e.target.value,"status")
                                    } }
                                    className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="draft">پیشنویس</option>
                                    <option value="publish">منتشر شده</option>
                                    <option value="private">خصوصی</option>
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="block">کد آسان</span>
                                <select
                                    value={query.has_asan_id || ""}
                                    onChange={ (e) => {
                                        changeQuery(e.target.value,"has_asan_id")
                                    } }
                                    className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="y">دارد</option>
                                    <option value="n">ندارد</option>
                                </select>
                            </label>
                        </div>

                        {/*stocks*/}
                        <div>
                            <label>
                                <span className="block">موجودی آسان</span>
                                <select 
                                    value={query.stock_asan || ""}
                                    onChange={ (e) => {
                                    changeQuery(e.target.value,"stock_asan")
                                } } className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="y">دارد</option>
                                    <option value="n">ندارد</option>
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="block">موجودی پردیس</span>
                                <select 
                                    value={query.stock_kourosh || ""}
                                    onChange={ (e) => {
                                    changeQuery(e.target.value,"stock_kourosh")
                                } } className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="y">دارد</option>
                                    <option value="n">ندارد</option>
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="block">موجودی ایران</span>
                                <select 
                                    value={query.stock_iran || ""}
                                    onChange={ (e) => {
                                    changeQuery(e.target.value,"stock_iran")
                                } } className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="y">دارد</option>
                                    <option value="n">ندارد</option>
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="block">موجودی فصلی</span>
                                <select 
                                    value={query.stock_franchise || ""}
                                    onChange={ (e) => {
                                    changeQuery(e.target.value,"stock_franchise")
                                } } className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="y">دارد</option>
                                    <option value="n">ندارد</option>
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="block">موجودی شرکت</span>
                                <select 
                                    value={query.stock_company || ""}
                                    onChange={ (e) => {
                                    changeQuery(e.target.value,"stock_company")
                                } } className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="y">دارد</option>
                                    <option value="n">ندارد</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">نیاز به تایید</span>
                                <select 
                                    value={query.is_reviewable || ""}
                                    onChange={ (e) => {
                                    changeQuery(e.target.value,"is_reviewable")
                                } } className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="y">دارد</option>
                                    <option value="n">ندارد</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">ارسال رایگان</span>
                                <select
                                    value={query.has_free_shipping_class || ""}
                                    onChange={ (e) => {
                                        changeQuery(e.target.value,"has_free_shipping_class")
                                    } }
                                    className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="tehran_and_alborz">تهران و البرز</option>
                                    <option value="province">شهرستان ها</option>
                                    <option value="both">هر دو</option>
                                    <option value="none">هیچکدام</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">ادغام ها</span>
                                <select
                                    value={query.external_shop_name || ""}
                                    onChange={ (e) => {
                                        changeQuery(e.target.value,"external_shop_name")
                                    } }
                                    className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="none">نشده</option>
                                    <option value="dgshahr">دیجیشهر</option>
                                    <option value="!dgshahr">بجز دیجیشهر</option>
                                    <option value="snapp">اسنپ شاپ</option>
                                    <option value="!snapp">بجز اسنپ شاپ</option>
                                    <option value="techno_life">تکنولایف</option>
                                    <option value="!techno_life">بجز تکنولایف</option>
                                    <option value="tapsi">تپسی</option>
                                    <option value="!tapsi">بجز تپسی</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">وضعیت در فروشگاه مجازی</span>
                                <select
                                    value={query.virtual_shop_status || ""}
                                    onChange={ (e) => {
                                        changeQuery(e.target.value,"virtual_shop_status")
                                    } }
                                    className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value={true}>فعال</option>
                                    <option value={false}>غیرفعال</option>
                                </select>
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="block">یکسان سازی خودکار قیمت</span>
                                <select
                                    value={query.auto_sync_virtual_store_price || ""}
                                    onChange={ (e) => {
                                        changeQuery(e.target.value,"auto_sync_virtual_store_price")
                                    } }
                                    className="bordered-input-7 bg-gray-1 w-full mt-1">
                                    <option value="">همه</option>
                                    <option value="y">بله</option>
                                    <option value="n">خیر</option>
                                </select>
                            </label>
                        </div>

                        {/*relations*/}
                        <div>
                            <label>
                                <span className="block">دسته بندی</span>
                                <CategorySelect2
                                    defaultValue={query.category || []}
                                    assignItem={handleMultiSelectCategory}
                                    placeholder="انتخاب دسته"
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="block">برند</span>
                                <BrandSelect2
                                    defaultValue={query.brand || []}
                                    assignItem={handleMultiSelectBrand}
                                    placeholder="انتخاب برند"
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="block">فروشگاه</span>
                                <ShopSelect
                                    hasFrontEnd={true}
                                    multiple={false}
                                    assignItem={handleMultiSelectShop}
                                placeholder="انتخاب فروشگاه"
                            />
                            </label>
                        </div>
                        {/*relations*/}


                        <div className="col-span-7">
                            <span className="block">جستجوی محصول</span>
                        <ProductSelect2
                                allowOutStock={true}
                                value={query.parent_id}
                                onChange={ (v) => {
                                    if (Array.isArray(v) && v.length > 0) {
                                        const ids = v.map(item => item._id).filter(Boolean);
                                        changeQuery(ids.length > 0 ? ids : null,'selected_ids');
                                    } else {
                                        changeQuery(null);
                                    }
                                } }
                                isMulti={true}
                        />
                        </div>

                        <div className="flex items-end">
                            <button
                                onClick={e => {
                                    setApplyFilter(true)
                                    setUpdateData(Date.now().toString())
                                }}
                                className="btn-orange w-full py-2">اعمال فیلتر
                            </button>

                            {applyFilter && (
                                <button
                                    onClick={resetFilters}
                                    className="btn-gray w-full py-2 mr-2"
                                >
                                    حذف فیلتر
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
